export default __webpack_public_path__ + "static/media/Mark-4-HUD-Header.0f864e85.jpg";